import { render, staticRenderFns } from "./DigitalCase.vue?vue&type=template&id=c3458c36&scoped=true&lang=pug&"
import script from "./DigitalCase.vue?vue&type=script&lang=js&"
export * from "./DigitalCase.vue?vue&type=script&lang=js&"
import style0 from "./DigitalCase.vue?vue&type=style&index=0&id=c3458c36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3458c36",
  null
  
)

export default component.exports